<template>
  <div>
    <ds-heading text="Estagiários" />
    <ds-row>
      <ds-col>
        <ds-button theme="primary" @click="onNew">
          Novo estagiário
        </ds-button>
      </ds-col>
    </ds-row>

    <ds-row vertical-offset="2">
      <ds-col>
        <ds-page>
          <interns-page-table>
          </interns-page-table>
        </ds-page>
      </ds-col>
    </ds-row>
  </div>
</template>

<script>
import InternsPageTable from './InternsPageTable.vue';

export default {
  name: 'InternsPage',
  components: {
    InternsPageTable,
  },
  data() {
    return {
      loading: false,
      interns: null,
    };
  },
  methods: {
    onNew() {
      this.$router.push({ name: 'NewIntern' });
    },
  },
};
</script>
